import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, SparklesIcon } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Te agarra ansiedad o duda cuando estás por avanzar', 'Te saboteás cuando algo empieza a salir bien', 'Te cuesta sostener límites y eso te drena', 'Te da culpa desear más (o recibir más)', 'Te cuesta ordenar el dinero sin sentir presión'];
  return <section className="w-full bg-cream-200 py-20 md:py-28 px-4" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-115">
          <h2 className="font-heading text-3xl md:text-4xl text-brown-700 text-center mb-6" data-id="element-116">
            El problema que resuelve
          </h2>

          <p className="text-lg text-brown-600 text-center mb-10" data-id="element-117">
            Capaz ya intentaste manifestar con afirmaciones, visualizaciones o
            rituales… pero igual:
          </p>

          <ul className="space-y-4 mb-10" data-id="element-118">
            {painPoints.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-white/60 backdrop-blur-sm p-4 rounded-xl shadow-sm" data-id="element-119">
                <AlertCircleIcon className="w-6 h-6 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-120" />
                <span className="text-brown-600" data-id="element-121">{point}</span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="bg-gradient-to-r from-gold-100 to-cream-100 p-6 rounded-2xl border border-gold-200" data-id="element-122">
            <div className="flex items-start gap-3" data-id="element-123">
              <SparklesIcon className="w-6 h-6 text-gold-600 flex-shrink-0 mt-1" data-id="element-124" />
              <div data-id="element-125">
                <p className="text-brown-600 mb-2" data-id="element-126">
                  <span className="font-semibold" data-id="element-127">
                    Esto suele pasar cuando el proceso está fragmentado.
                  </span>
                </p>
                <p className="text-brown-700 font-medium" data-id="element-128">
                  Esta guía te da una hoja de ruta clara, para que tu energía,
                  tus decisiones y tus acciones empiecen a ir en la misma
                  dirección.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}